<template>
  <div>
    <div class="">
      <div
        v-if="room.isVisible"
        class="box"
        style="margin-bottom:1rem; padding-bottom: 0px;"
      >
        <div style="margin-bottom:1rem; padding-bottom: 0px;">
          <div class="columns">
            <div class="column">
              <div class="mb-3">
                <b class="has-text-black capitalize"
                  >{{ room.description.bedMessage }}
                </b>

                <span
                  class="is-size-6 is-hidden-desktop has-text-weight-bold is-pulled-right has-text-right"
                >
                  ${{ room.requestedCurrencyPricing.dailyRate }}
                </span>
              </div>

              <div>
                <b-tag
                  v-if="room.enhancedPricing.guaranteeType"
                  class="p-1 has-text-grey-dark has-background-white-ter mr-2 is-size-7 mb-1"
                  >{{ room.enhancedPricing.guaranteeType | guarantees }}</b-tag
                >
                <b-tag
                  v-if="room.nonrefundable"
                  class="p-1 has-text-grey-dark has-background-white-ter mr-2 is-size-7 mb-1"
                  >Non-refundable</b-tag
                >
                <b-tag
                  class="p-1 has-text-grey-dark has-background-white-ter mr-2 is-size-7 mb-1"
                  >Rate plan: {{ room.enhancedPricing.ratePlanCode }}
                </b-tag>

                <b-tooltip
                  class=""
                  v-if="room.breakfastIncluded"
                  type="is-light"
                  position="is-bottom"
                  multilined
                >
                  <b-icon
                    class=""
                    icon="silverware-fork-knife"
                    size="is-small"
                  ></b-icon>
                  <template v-slot:content style="background-color: white;">
                    Breakfast included
                  </template>
                </b-tooltip>
              </div>

              <div
                class="is-size-7 has-text-grey capitalize"
                style="font-size: 12px;"
              >
                {{ room.textDescription }}
              </div>

              <div v-if="room.cancelPenalties">
                <div
                  v-for="(cancelPenalty, index) in room.cancelPenalties"
                  :key="index"
                >
                  <CancelPenalty :cancelPenalty="cancelPenalty"></CancelPenalty>
                </div>
              </div>

              <div class="has-flex">
                <b-button
                  size="is-small"
                  type="is-secondary"
                  class="mt-3"
                  @click="epTabOpen = !epTabOpen"
                >
                  <span v-if="!epTabOpen"
                    >View Rate / Cancellation Details</span
                  >
                  <span v-else>Hide Rate / Cancellation Details</span>
                </b-button>
              </div>
              <KeepAlive>
                <EnhancedPricingTab
                  v-if="epTabOpen"
                  :sol="room"
                  :session="session"
                />
              </KeepAlive>
            </div>

            <div class="column is-narrow">
              <div class="is-flex is-flex-direction-column is-align-items-end">
                <div class="is-size-4 has-font-weight-bold has-text-right">
                  <b-tooltip
                    v-if="currencyConverted"
                    class="is-size-5"
                    type="is-dark"
                    position="is-bottom"
                  >
                    <template v-slot:content>
                      {{ currencyConvertedMessage }}
                    </template>
                    <b-icon
                      type="is-success"
                      icon="approximately-equal"
                      size="is-small"
                    >
                    </b-icon>
                  </b-tooltip>

                  <div>${{ room.requestedCurrencyPricing.dailyRate }}</div>
                  <div style="font-size: 10px; color: gray;">
                    x {{ room.nights }} nights
                  </div>
                </div>

                <div class="is-size-6 has-text-grey">
                  ${{ room.requestedCurrencyPricing.total }} total
                </div>

                <div 
                  class="is-size-7 is-clickable gant-text"
                  @click="epTabOpen = !epTabOpen"
                >
                  <span v-if="!epTabOpen">Show Price Breakdown</span> <span v-else>Hide Price Breakdown</span>
                </div>

                <div class="mt-2">
                  <OutOfPolicyTag
                    :travelPolicy="room.travelPolicy"
                    class=""
                  ></OutOfPolicyTag>
                </div>
              </div>

              <div class="mt-2">
                <!-- Immediate travel -->
                <div v-if="room.immediateTravelBookingAdvice" class="">
                  <ImmediateTravelNote
                    :severity="room.immediateTravelBookingAdvice"
                  />
                </div>
                <!-- End Immediate travel -->

                <div
                  v-if="!room.isSelectable"
                  class="mt-4 is-size-7 has-text-grey has-text-right"
                >
                  Not selectable
                </div>

                <div
                  v-if="
                    room.isSelectable &&
                      room.immediateTravelBookingAdvice == 'prevent'
                  "
                  class="mt-4 notification is-size-7 has-text-grey has-text-centered"
                >
                  To book this option call: <br />
                  877-924-0303
                </div>
                <b-button
                  v-if="
                    room.isSelectable &&
                      room.immediateTravelBookingAdvice != 'prevent'
                  "
                  type="is-primary"
                  size="is-small"
                  class="is-fullwidth mt-1"
                  @click="submitted(room)"
                >
                  Select Room
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
import modalMixin from "@/mixins/modalMixin";
import OutOfPolicyTag from "../../Tags/OutOfPolicyTag.vue";
import CancelPenalty from "./CancelPenalty";
import ImmediateTravelNote from "../../Traveller/ImmediateTravelNote";
import EnhancedPricingTab from "@/components/BookTravel/Hotel/EnhancedPricingTab";

export default {
  name: "HRoom",
  mixins: [bookingMixin, modalMixin],
  components: {
    OutOfPolicyTag,
    CancelPenalty,
    ImmediateTravelNote,
    EnhancedPricingTab,
  },
  props: {
    room: Object,
    session: String,
  },
  data: function() {
    return {
      epTabOpen: false,
    };
  },
  computed: {
    triptype() {
      return this.$store.state.bookTravel.result.itineraryType;
    },
    currencyConverted() {
      return (
        this.room.sourceCurrencyPricing.currencyCode !=
        this.room.requestedCurrencyPricing.currencyCode
      );
    },
    currencyConvertedMessage() {
      if (!this.currencyConverted) return null;

      var msg =
        "Approximate Total - The currency has been converted from " +
        this.room.sourceCurrencyPricing.total +
        " " +
        this.room.sourceCurrencyPricing.currencyCode +
        " to " +
        this.room.requestedCurrencyPricing.total +
        " " +
        this.room.requestedCurrencyPricing.currencyCode;

      return msg;
    },
  },
  methods: {
    submitted(room) {
      // console.log('room selected', room);

      if (room.immediateTravelBookingAdvice == "warn") {
        this.$buefy.dialog.confirm({
          message:
            "You have selected a hotel with a check-in time in the next few hours. Please watch your email for your Final Itinerary.  If you do not receive your Final Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.",
          confirmText: "Continue booking",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.$emit("selected", room),
        });
      } else {
        this.$emit("selected", room);
      }
    },
  },
};
</script>

<style scoped></style>
